export const VIDEO_RIGHT_PANE_SPLIT_CONFIG = {
  defaultRatio: 0.75,
  minRatio: 0.4,
  maxRatio: 0.85,
  minRightPaneWidth: 320,
  storageKey: 'viewer-video-split-ratio',
} as const;
